import React from 'react';
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    useTheme,
    useMediaQuery
} from '@mui/material';import Footer from './Footer';

const ServicesPage = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const services = [
        {
            title: 'Floor Tile',
            description: 'Professional tile installation for floors, including ceramic, porcelain, and natural stone tiles. We handle everything from design consultation to final grouting.',
            features: ['Ceramic & Porcelain', 'Natural Stone', 'Custom Patterns', 'Professional Installation']
        },
        {
            title: 'Wall Tile',
            description: 'Specialized tile installation for bathrooms, showers, and wall applications. We create beautiful, functional spaces with proper waterproofing and attention to detail.',
            features: ['Shower Installation', 'Backsplash Design', 'Waterproofing', 'Custom Patterns']
        },
        {
            title: 'Hardwood',
            description: 'Premium hardwood flooring installation and refinishing services. We work with a variety of wood species to create timeless, durable floors that add value to your home.',
            features: ['Installation', 'Refinishing', 'Repair', 'Maintenance']
        },
        {
            title: 'Vinyl Plank',
            description: 'Modern vinyl plank flooring that combines the look of hardwood with superior durability and water resistance. Perfect for high-traffic areas and moisture-prone spaces.',
            features: ['Waterproof Options', 'Easy Maintenance', 'Durable', 'Versatile Design']
        },
        {
            title: 'Laminate',
            description: 'Cost-effective laminate flooring that provides the beauty of hardwood at a fraction of the cost. Ideal for budget-conscious homeowners who want style and durability.',
            features: ['Budget-Friendly', 'Easy Installation', 'Scratch Resistant', 'Low Maintenance']
        },
    ];

    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundColor: theme.palette.background.main,
                pt: isMobile ? 12 : 12,
                pb: 8
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    variant="h1"
                    align="center"
                    sx={{
                        fontFamily: '"Nexa Slab Regular", serif',
                        textTransform: 'uppercase',
                        fontWeight: 700,
                        fontSize: { xs: '3rem', md: '3rem' },
                        my: { xs: 2, md: 2 },
                        color: 'white'
                    }}
                >
                    Services
                </Typography>
                <Typography
                    variant="h5"
                    align="center"
                    sx={{
                        color: 'primary.main',
                        fontWeight: 300,
                        mb: 6,
                        maxWidth: '800px',
                        mx: 'auto'
                    }}
                >
                    We offer professional installation services for all your flooring needs.
                </Typography>
            <Grid container spacing={4}
                sx={{
                    // border: '1px solid red',
                }}
            >
                {services.map((service, index) => (
                    <Grid item xs={12} sm={12} md={6} lg={4} key={index}
                        sx={{
                            // border: '1px solid blue',
                            width: { xs: '100%', sm: '100%', md: 'auto', lg: 'auto' },
                        }}
                    >
                        <Card
                            sx={{
                                height: '100%',
                                width: '100%',
                                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                                cursor: 'default',
                                '&:hover': {
                                    // transform: 'translateY(-8px)',
                                    // boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)'
                                }
                            }}
                        >
                            <CardContent sx={{ px: 3, py: "0px !important" }}>
                                <Typography
                                    variant="body1"
                                    textAlign="center"
                                    sx={{
                                        fontFamily: '"Nexa Slab Regular", serif',
                                        fontWeight: 100,
                                        color: 'white',
                                        py: 2,
                                        // mb: 2,
                                        fontSize: { xs: '1.5rem', md: '1.75rem' }
                                    }}
                                >
                                    {service.title}
                                </Typography>
                                {/* <Typography
                                    variant="body1"
                                    sx={{
                                        color: 'rgba(255, 255, 255, 0.8)',
                                        mb: 3,
                                        lineHeight: 1.6
                                    }}
                                >
                                    {service.description}
                                </Typography> */}
                                <Box>
                                    {/* {service.features.map((feature, featureIndex) => (
                                        <Typography
                                            key={featureIndex}
                                            variant="body2"
                                            sx={{
                                                color: 'primary.main',
                                                mb: 0.5,
                                                '&::before': {
                                                    content: '"✓ "',
                                                    color: 'primary.main',
                                                    fontWeight: 'bold'
                                                }
                                            }}
                                        >
                                            {feature}
                                        </Typography>
                                    ))} */}
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            </Container>
            <Footer />
    </Box >
  );
};

export default ServicesPage; 